import React from 'react';
import cn from 'classnames';
import s from '../../Transaction.module.scss';
import { FormFieldWrapper } from '../../../../../../../../components';
import { useFormContext, Controller } from 'react-hook-form';
import Input from '../../../../../../../../components/UIWidgets/Input/Input';

interface IOwnProps {
  label: string;
  name: string;
  disabled?: boolean;
  maxDecimals?: number;
  placeholder?: string;
}

export const TextField = ({ label, name, disabled, maxDecimals = 2, placeholder = "Optional" }: IOwnProps) => {
  const { control } = useFormContext();

  return (
    <FormFieldWrapper label={label} required={false} className={cn(s.noteField)}>
      <Controller name={name} control={control} as={TextInput} maxDecimals={maxDecimals} disabled={disabled} placeholder={placeholder} />
    </FormFieldWrapper>
  );
};

const TextInput = ({ value, onChange, disabled, maxDecimals = 2, ...rest }: any) => {
  return (
    <Input
      autoComplete="off"
      name={'commission'}
      disabled={disabled}
      value={value}
      style={{backgroundColor: "var(--secondary-bg"}}
      onChange={({ target }) => {
        onChange(target.value);
      }}
      {...rest}
    />
  );
};
